import { __assign } from "tslib";
import React from 'react';
import { Card } from '@keen.io/ui-core';
import { Layout, TitleSocket, LegendSocket } from './chart-widget.styles';
var Widget = function (_a) {
    var title = _a.title, legendSettings = _a.legendSettings, content = _a.content, legend = _a.legend;
    var legendComponent = legend();
    var titleComponent = title();
    var contentComponent = content();
    return (React.createElement(React.Fragment, null,
        React.createElement(TitleSocket, { "data-testid": "title-socket" }, titleComponent),
        React.createElement(Layout, { legendPosition: legendSettings.position },
            legendComponent && (React.createElement(LegendSocket, __assign({}, legendSettings, { "data-testid": "legend-socket" }), legendComponent)),
            contentComponent)));
};
var ChartWidget = function (_a) {
    var title = _a.title, legend = _a.legend, content = _a.content, cardSettings = _a.cardSettings, legendSettings = _a.legendSettings;
    return (React.createElement(Card, __assign({}, cardSettings),
        React.createElement(Widget, { title: title, legendSettings: legendSettings, legend: legend, content: content })));
};
export default ChartWidget;
